import {  Alert, Box, Button, DialogActions, DialogContent, DialogTitle, FormControlLabel, Grid,  LinearProgress,  MenuItem,  Paper, Select, Snackbar, SnackbarCloseReason, Switch } from '@mui/material';
import { useState } from 'react';
import {  AutoCompleteParceiroListagem } from '../../../shared/forms';
import { RelatorioRomaneiosService } from '../../../shared/services/api/faturamento/romaneios/RRelatorios';
import { DatePicker, LocalizationProvider } from '@mui/x-date-pickers';
import dayjs, { Dayjs } from 'dayjs';
import { AdapterDayjs } from '@mui/x-date-pickers/AdapterDayjs';
import RRelatorioRomaneioDetalhes from './RRelatorioRomaneioDetalhes';
import RRomaneioResumido from './RRomaneioResumido';
           
export const RelatoriosRomaneios: React.FC = () => {                      
  const [isLoading, setIsLoading] = useState(false);      
  const [uidparceiro, setUidParceiros] = useState('');           
  const [status, setStatus] = useState('todos');    
  const [dataInicial, setDataInicial] = useState<Dayjs | null>(dayjs()); 
  const [dataFinal, setDataFinal] = useState<Dayjs | null>(dayjs()); 
  const [detalhes, setDetalhes] = useState(false);   
  const [openmsg, setOpenmsg] = useState(false);
  const [msg, setMsg] = useState('');
  const [tms, setTms] = useState<'warning' | 'error'  | 'info'  | 'success'>('warning');  
              
  const handleCloseMsg = (
    event?: React.SyntheticEvent | Event, 
    reason?: SnackbarCloseReason,
  ) => {
    if (reason === 'clickaway') {
      return;
    }
    setOpenmsg(false);
  };   
      
  const handleSave = () => {              
    RelatorioRomaneiosService                   
      .RRomaneios(status, uidparceiro, dayjs(dataInicial).format('DD/MM/YYYY'), dayjs(dataFinal).format('DD/MM/YYYY'), detalhes)   
      .then((result) => {           
        setIsLoading(false);              
        if (result instanceof Error) {                
          setTms('error');
          setMsg(result.message);
          setOpenmsg(true);             
        }else {   
          if(result.length > 0){
            if(detalhes){
              RRelatorioRomaneioDetalhes(result, dayjs(dataInicial).format('DD/MM/YYYY'), dayjs(dataFinal).format('DD/MM/YYYY'));  
            }else{
              RRomaneioResumido(result, dayjs(dataInicial).format('DD/MM/YYYY'), dayjs(dataFinal).format('DD/MM/YYYY'));  
            }     
          }else{
            setTms('warning');
            setMsg('Nenhum registro encontrado');
            setOpenmsg(true);  
          }       
        }          
      });    
  };    

  const handleParceiros = (uuidparceiro: string | undefined) => {
    if (uuidparceiro != null) {
      setUidParceiros(uuidparceiro);
    }else{
      setUidParceiros('');
    }
  };

  return (
    <Box   alignItems="center" width='100%' alignContent='center' height="100%"  display="flex" flexDirection="column"  >
      <Snackbar anchorOrigin={{ vertical: 'top', horizontal: 'center' }} open={openmsg}  autoHideDuration={900} onClose={handleCloseMsg}>
        <Alert
          onClose={handleCloseMsg}
          severity={tms}
          variant="filled"
          sx={{ width: '100%' }}
        >
          {msg}
        </Alert>
      </Snackbar>
      <Box gap={1}   padding={1} paddingX={2} display="flex" alignItems="center" alignSelf='center' width='80%' height="20%" alignContent='center'></Box>
      <Box    width='auto' alignItems="center"  component={Paper} height="auto"
        alignContent='center'>       
        <DialogTitle>Relatório de Romaneios</DialogTitle>
        <DialogContent  dividers>
          
          {isLoading && (
            <Grid item>
              <LinearProgress variant='indeterminate' />  
            </Grid>                         
          )}   
          <Grid container  item direction="row" >
            <Grid container spacing={1} item direction="row" xs={12} sm={12} md={12} lg={12} xl={12}>
              <Grid item xs={12} sm={12} md={12} lg={12} xl={12}>
                <AutoCompleteParceiroListagem
                  uuidparceiro={handleParceiros} 
                />                 
              </Grid>        
              <Grid item xs={6} sm={6} md={3} lg={3} xl={3}>
                <LocalizationProvider dateAdapter={AdapterDayjs}>
                  <DatePicker
                    format='DD/MM/YYYY'    
                    value={dataInicial}
                    onChange={(newValue) => setDataInicial(newValue)} 
                    slotProps={{
                      textField: {    
                        size:'small',
                      }
                    }}
                  />
                </LocalizationProvider>
              </Grid>  
              <Grid item xs={6} sm={6} md={3} lg={3} xl={3}>
                <LocalizationProvider dateAdapter={AdapterDayjs}>
                  <DatePicker
                    format='DD/MM/YYYY'
                    value={dataFinal}
                    onChange={(newValue) => setDataFinal(newValue)} 
                    slotProps={{
                      textField: {    
                        size:'small', 
                      }
                    }}    
                  />
                </LocalizationProvider>
              </Grid>      
              <Grid item xs={6} sm={6} md={4} lg={4} xl={4}>
                <Select
                  fullWidth
                  size='small'
                  value={status}
                  onChange={(event) => setStatus(event.target.value)}
                >
                  <MenuItem value={'aberto'}>Aberto</MenuItem>
                  <MenuItem value={'abertovencimento'}>Aberto Por Vencimento</MenuItem>
                  <MenuItem value={'fechado'}>Fechado</MenuItem>
                  <MenuItem value={'todos'}>Todos</MenuItem>
                </Select>           
              </Grid>   
              <Grid item xs={2} sm={2} md={2} lg={2} xl={2}>
                <FormControlLabel
                  labelPlacement="top"
                  control={
                    <Switch 
                      size='small'
                      checked={detalhes}
                      onChange={(e) => setDetalhes(e.target.checked)} 
                    />    
                  } 
                  label = 'Detalhes'
                />         
              </Grid>          
            </Grid>        
          </Grid>         
        </DialogContent >     
        <DialogActions>
          <Button variant='outlined' autoFocus onClick={handleSave}>Visualizar</Button>
        </DialogActions>
      </Box>
    </Box>
  );
};   